<template>
  <div class="image-block">
    <img :src="data.path">
  </div>
</template>

<script>
export default {
  name: 'imageblock',
  props: ['data'],
}
</script>



// WEBPACK FOOTER //
// BlockImage.vue?4ea83c4a